
            const data = {"name":"ic_radio","data":{"width":"20","height":"20","viewBox":"0 0 20 20","data":"<circle pid=\"0\" cx=\"10\" cy=\"10\" r=\"8.5\" _stroke=\"#C4C4C4\" stroke-width=\"3\"/>","originalColors":[{"type":"stroke","color":"#C4C4C4"}],"stopColors":[]}}
        
                module.exports = data
                